<template>
  <div class="mapType">
    <div class="p-line"></div>
    <div class="p-opacityslider-wrap">
      <div class="chooseType">
        <p>地图类型</p>
        <el-select size="mini" v-model="statusValue" placeholder="选择类型">
          <el-option
            v-for="(key, item) in mapType"
            :key="key"
            :label="item"
            :value="item"
            @click="selectOption"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mapType',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      value: this.propertyData.mapType.value,
      statusValue: '',
      mapType: {
        天地图: 9,
        // 高德地图: 1,
        // 百度地图: 2,
        超图地图: 5,
        '51world地图': 6,
      },
      mapList: {
        9: '天地图',
        // 1: '高德地图',
        // 2: '百度地图',
        5: '超图地图',
        6: '51world地图',
      },
    };
  },
  created() {
    this.setData();
  },
  methods: {
    setData() {
      this.statusValue = this.mapList[this.value.maptype];
    },
    selectOption() {
      this.value.maptype = this.mapType[this.statusValue];
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: this.value,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/* .mapType {

} */
.chooseType {
  width: 100%;
  // padding-bottom: 10px;
  box-sizing: border-box;
  .p-lable {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    color: #5b5c66;
    font-size: 12px;
    line-height: 30px;
  }
}
.demo-input-label {
  display: inline-block;
  width: 130px;
}
.chooseType > {
  div {
    display: flex;
    align-items: center;
  }
  p {
    box-sizing: border-box;
    color: #a0a1b4;
    width: 80px;
    text-align: center;
    height: 30px;
    font-size: 14px;
    line-height: 30px;
  }
}

.p-opacityslider-wrap {
  display: flex;
  align-items: center;
  width: 100%;
}
.chooseType {
  display: flex;
  align-items: center;
  .el-select {
    /* width: 192px; */

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
.mapType .p-line {
  width: 100%;
  height: 1px;
  background-image: linear-gradient(to left, rgba(204, 204, 204, 0), #8f8f8f, rgba(204, 204, 204, 0));
  margin-bottom: 5px;
}
</style>
